import DataService from './dataService/dataService';

let serviceModule = angular.module('app.services', [
  DataService.name
]);

export default serviceModule;



// WEBPACK FOOTER //
// ./app/services/services.js